// extracted by mini-css-extract-plugin
export var scrollArea = "_p5-0";